import { apiClient } from '@/hooks/useAxios';
import { CommonRes, Options } from '@/types';

const ApiPath = '/options';

export const fetchOptions = async (
  field: string,
): Promise<CommonRes<Options>> => {
  const params = field ? { field } : undefined;
  const res = await apiClient.get<CommonRes<Options>>(`${ApiPath}`, { params });
  return res.data;
};
